import { z } from 'zod';
import {
    BIGDES_IMPLEMENTATION_PROCESS_AUDIT_METHODS,
    BIGDES_IMPLEMENTATION_PROCESS_EFFECTIVENESS_STATUSES,
} from './bigdes-implementation-process-evaluation.constants.js';

export const UpdateBigdesImplementationProcessEvaluationSchema = z.object({
    auditMethods: z.array(z.enum(BIGDES_IMPLEMENTATION_PROCESS_AUDIT_METHODS)).optional(),
    workFormNo: z.string().trim().max(500).optional(),
    effectivenessStatus: z.enum(BIGDES_IMPLEMENTATION_PROCESS_EFFECTIVENESS_STATUSES).nullable().optional(),
});
